import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

/*
  Generated class for the LocupaUtilsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocupaUtilsServiceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello LocupaUtilsServiceProvider Provider');
  }

  groupBy(list: any[], keyGetter): Map<any, any> {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
}




// WEBPACK FOOTER //
// ./src/providers/locupa-utils-service/locupa-utils-service.ts